import { AuthService } from '@aipb/auth';
import {
  CoopSummaryResponse,
  ListCollections3ifInnerParams,
  RestRequest,
  UserGetInfoModel,
  UserTreeCollectionModel
} from '@aipb/personal-content/shared/model';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalContentApiService } from '../personal-content-api.service';
import { UserApiInterface } from './user-api.interface';
import { GetCoopSummaryParams } from './user-api.params';

@Injectable({
  providedIn: 'root'
})
export class UserApiService implements UserApiInterface {
  constructor(private api: PersonalContentApiService, private auth: AuthService) {}

  getInfo(): Observable<UserGetInfoModel> {
    return this.api.post('userGetInfo');
  }

  getCoopSummary(params: GetCoopSummaryParams = {}): Observable<CoopSummaryResponse> {
    return this.api.post('userGetCoopSummary', params);
  }

  listCollections(): Observable<UserTreeCollectionModel[]> {
    return this.api.post('userListCollections');
  }

  listCollections3if(): string {
    const url = new URL(this.api.baseUrl);

    const request: RestRequest = 'userListCollections3if';
    url.searchParams.append('request', request);

    if (!this.auth.isLoggedIn()) {
      // @ts-expect-error foo
      return null;
    }

    url.searchParams.append('uniqueId', this.auth.getUserId());

    return url.toString();
  }

  listCollections3ifInner(params: ListCollections3ifInnerParams): string {
    const url = new URL(this.api.baseUrl);

    const request: RestRequest = 'userListCollections3if_inner';

    url.searchParams.append('request', request);
    url.searchParams.append('uniqueId', params.uniqueId);

    return url.toString();
  }
}
